import React from 'react'
import { Avatar } from 'components'
import styled from 'styled-components'
import { rgba, media, colors } from 'styles'

const StyledMatch = styled.div`
  position: relative;
  width: 100%;

  .user-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1.5rem 2rem;
    border-radius: 0 0 1rem 1rem;
    background-color: ${rgba(colors.main, 0.8)};
    color: ${colors.mainInverted};
    font-size: 1.2rem;

    .username-age {
      margin-bottom: 0.8rem;
      font-size: 1.25em;
    }
  }

  ${media.mobile`
    .user-info {
      font-size: 1.6rem;
    }
  `}
`

const Match = ({ flirtUser: user }) => (
  <StyledMatch>
    <Avatar user={user} source="flirt" />
    <div className="user-info">
      <div className="username-age">
        <strong>{user.screenName}</strong>, {user.age}
      </div>
      <div className="location">
        {user.city}, {user.country}
      </div>
    </div>
  </StyledMatch>
)

export default Match
